import React from 'react';
import { Link } from 'react-router-dom';
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/software-company-components/Footer/Footer";
import SEO from "../../components/SEO";
import Digital from "../../images/services/digitalMarketing.jpg";
import "../../css/animate.css";
import "../DigitalMarketing/DigitalMarketing.css";


function DigitalMarketing() {
  return (
    <div>
        <SEO
            title="Grow Your Business Online with Unified Consulting Services"
            description="Unified Consulting Services helps you grow your business online with proven SEO, paid ads, and social media strategies tailored to your goals."
            url="https://www.ufsnetworks.com/digital-marketing"
            image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
            canonicalUrl="https://www.ufsnetworks.com/digital-marketing"
        />
        <Header2 />
        <main style={{height:"100px", overflow:"hidden"}}>
            <PageTitle
            // pageTitle={"Grow Your Business Online with Unified Digital Marketing"}
            // pagesub={"Unified Digital Marketing"}
            // pageTop={""}
            />
            </main>
            <div className='animated fadeIn'>
                <div className='bannerContainer'>
                   <div className='' style={{width:"50%", height:"100%", display:"flex", flexDirection:"column", padding:"0px 50px", justifyContent:"center"}}>
                        <h2 className='text-white' style={{background: 'linear-gradient(90deg, #f4ff2f, #00f3ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontSize: '4rem', fontWeight: 'bold', marginBottom:"32px"}}>Grow Your Business Online with Unified Digital Marketing</h2>
                       
                        <p style={{color:"#fff", fontSize:"1.2rem"}}>At Unified Consultancy Services, we help businesses like yours attract, engage, and convert customers through intelligent, data-driven digital marketing solutions. Whether you’re looking to increase website traffic, improve search rankings, or boost social engagement — we have the expertise to make it happen.
                        </p>
                        <div className='mt-4'>
                            <Link to="/contact" className='contactBtn'>Contact us today for a free consultation</Link>
                        </div>
                   </div>
                </div>
                <div className='container'>
                    <h2 className='Title-text'>Our Digital Marketing Services Include:</h2>
                    <div className='custom-grid'>
                        <div className='box'>
                            <h4>🔍 Search Engine Optimization (SEO)</h4>
                            <p>Boost your visibility on Google and other search engines.</p>
                            <ul>
                                <li>On-page & off-page optimization</li>
                                <li>Technical SEO and keyword research</li>
                                <li>Local SEO to dominate your regional market</li>
                            </ul>
                        </div>
                        <div className='box'>
                            <h3>📢 Pay-Per-Click Advertising (PPC)</h3>
                            <p>Google Ads, Bing Ads, and social PPC campaigns.</p>
                            <ul>
                                <li>Maximize ROI with strategic targeting and budget control</li>
                                <li>Transparent reporting and ongoing optimization</li>
                            </ul>
                        </div>
                        <div  className='box'>
                            <h3>📲 Social Media Marketing</h3>
                            <p>Build a loyal audience across platforms like Facebook, Instagram, LinkedIn & X (Twitter).</p>
                            <ul>
                                <li>Custom content creation, paid ads, and community engagement</li>
                                <li>Analytics-driven growth strategies</li>
                            </ul>
                        </div>
                        <div className='box'>
                            <h3>📧 Email Marketing</h3>
                            <p>Convert leads into customers with powerful email campaigns.</p>
                            <ul>
                                <li>Personalized automation and performance tracking</li>
                                <li>Nurture your audience with value-driven content</li>
                            </ul>
                        </div>
                        <div className='box'>
                            <h3>🖥️ Content Marketing</h3>
                            <p>Inform, engage, and convert with blog posts, videos, and infographics.</p>
                            <ul>
                                <li>Content strategies aligned with your business goals</li>
                                <li>SEO-focused storytelling that builds brand authority</li>
                            </ul>
                        </div>
                        <div className='box'>
                            <h3>🌐 Website & Conversion Optimization</h3>
                            <p>Improve your site for better performance and conversions.</p>
                            <ul>
                                <li>Landing pages and funnel optimization</li>
                                <li>UX/UI improvements that increase time-on-site</li>
                                <li>A/B testing and performance audits</li>
                            </ul>
                        </div>
                    </div>

    

    

    

    

    

    <h2 className='mt-4'>💡 Why Choose Us?</h2>
    <ul className='p-left-24'>
      <li>🎯 <span class="highlight">Results-Focused Strategies</span>: Every click, like, and conversion is tracked and optimized.</li>
      <li>🤝 <span class="highlight">Client-First Approach</span>: We work as an extension of your team, not just a vendor.</li>
      <li>📊 <span class="highlight">Transparent Reporting</span>: Clear, concise performance updates — no jargon, no fluff.</li>
      <li>🌍 <span class="highlight">Multi-Industry Expertise</span>: From startups to enterprises across e-commerce, B2B, real estate, healthcare, and more.</li>
    </ul>

    <div class="cta">
      <p>📞 <strong>Ready to Take Your Digital Presence to the Next Level?</strong></p>
      <p>Whether you're starting from scratch or scaling an existing campaign, <strong>Unified Consulting Services</strong> has the tools and talent to deliver results. Let’s grow your business together.</p>
      <div className='mt-4 mb-4'>
                            <Link to="/contact" className='contactBtn'>Contact us today for a free consultation</Link>
                        </div>
    </div>
                </div>
            </div>
            <Footer/>
      <Scrollbar />
    </div>
  )
}

export default DigitalMarketing
